export default __webpack_public_path__ + "static/media/deviceSettingsIcon.9ca343fa.svg";